import { AuthProvider } from "react-admin";
import keycloak from "./keycloak";
import { httpClient } from "./httpClient";


const apiUrl = "/api";
const keycloakUrl = "/keycloak";
const STORAGE_KEY = "selectedClub";

async function ensureClubSelectedForAuth() {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (raw) return;

  const { json } = await httpClient(`${apiUrl}/users/assignable-clubs`);
  const clubs = json as { id: number; display_name: string }[];

  if (clubs.length === 1) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(clubs[0]));
  }

}

export const authProvider: AuthProvider = {
  login: async () => {
    // App-init macht login-required bereits
    if (!keycloak.authenticated) {
      await keycloak.login({ redirectUri: window.location.origin });
    }
  },

  logout: async () => {
    await keycloak.logout({ redirectUri: window.location.origin });
  },

  checkAuth: async () => {
  if (!keycloak.authenticated) {
    return Promise.reject();
  }

  try {
    // erzwingt ggf. Refresh
    await keycloak.updateToken(60);
    return Promise.resolve();
  } catch {
    return Promise.reject();
  }
},

  checkError: async (error: any) => {
    const status = error?.status || error?.response?.status;
    if (status === 401 ) throw new Error("Unauthorized");
  },

  getIdentity: async () => {
    await ensureClubSelectedForAuth();

    const raw = localStorage.getItem(STORAGE_KEY);
    const club = raw ? JSON.parse(raw) : null;
    const clubId = club?.id;

    const url = clubId
      ? `${apiUrl}/me?club_id=${clubId}`
      : `${apiUrl}/me`;

    const { json } = await httpClient(url);
    return json
  },

  getPermissions: async () => {

    await ensureClubSelectedForAuth();
    const raw = localStorage.getItem("selectedClub");
    const club = raw ? JSON.parse(raw) : null;
    const clubId = club?.id;

    const url = clubId ? `${apiUrl}/me?club_id=${clubId}` : `${apiUrl}/me`;
    const { json } = await httpClient(url);

    // Gib nur die permissions zurück (RA cached das Ergebnis)
    return json.permissions;
  },
};
